/* eslint-disable */
import request from './helpers'

export function getJobStoreList() {
  return request({
    url: '/api/v1/store',
    method: 'get'
  })
}

export function getJobStoreListDetail() {
  return request({
    url: '/api/v1/store/details',
    method: 'get'
  })
}

export function deleteJobStore(id) {
  return request({
    url: '/api/v1/store/' + id,
    method: 'delete'
  })
}

export function getJobStoreProperties(id) {
  return request({
    url: '/api/v1/store/properties/' + id,
    method: 'get'
  })
}

export function getJobStoreTemplate(params) {
  return request({
    url: '/api/v1/store/templates',
    method: 'get',
    params
  })
}

export function updateJobStore(id, data) {
  return request({
    url: '/api/v1/store/' + id,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function createJobStore(data) {
  return request({
    url: '/api/v1/store',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function getJobList (params) {
  return request({
    url: '/api/v1/job',
    method: 'get',
    params
  })
}

export function deleteJobs (params) {
  return request({
    url: '/api/v1/job',
    method: 'delete',
    params
  })
}
export function getJob (id) {
  return request({
    url: '/api/v1/job/' + id,
    method: 'get'
  })
}

export function testJob (id) {
  return request({
    url: '/api/v1/job/' + id + '/test',
    method: 'get'
  })
}

export function triggerJob (id) {
  return request({
    url: '/api/v1/job/' + id + '/trigger',
    method: 'get'
  })
}

export function createCronJob (data) {
  return request({
    url: '/api/v1/job',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function createDelayJob (data) {
  return request({
    url: '/api/v1/job/delay',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function createFixedTimeJob (data) {
  return request({
    url: '/api/v1/job/fixedtime',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function updateCronJob (id, data) {
  return request({
    url: '/api/v1/job/' + id,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function updateDelayJob (id, data) {
  return request({
    url: '/api/v1/job/delay/' + id,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function updateFixedTimeJob (id, data) {
  return request({
    url: '/api/v1/job/fixedtime/' + id,
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data
  })
}

export function activeJob (id, active) {
  return request({
    url: '/api/v1/job/' + id + '/status',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      id,
      active
    }
  })
}

export function deleteJob (id) {
  return request({
    url: '/api/v1/job/' + id,
    method: 'delete'
  })
}

export function getDedicatedJob () {
  return request({
    url: '/api/v1/store/dedicated',
    method: 'get'
  })
}

export function getDedicatedJobByDc (dcName) {
  return request({
    url: '/api/v1/store/dedicated/' + dcName,
    method: 'get'
  })
}
